export default {
    name: 'companies',
    component: () => import(/* webpackChunkName: "companies-Layout" */ '@/modules/companies/layouts/Layout'),
    children: [
        {
            path: '',
            name: 'dashboard.companies.index',
            component: () => import(/* webpackChunkName: "companies-index" */ '@/modules/companies/views/Index'),
        },
        {
            path: 'create',
            name: 'dashboard.companies.create',
            component: () => import(/* webpackChunkName: "companies-create" */ '@/modules/companies/views/Create'),
        },
        {
            path: ':id/edit',
            name: 'dashboard.companies.edit',
            component: () => import(/* webpackChunkName: "companies-edit" */ '@/modules/companies/views/Edit'),
        },
    ]
}